import React from 'react';


class About extends React.Component {
    render() {
      return (
        
        <section className="about" id="welcome-section">
          <h1> Hello! I am Angie ... =) </h1>
          <p> $web development studient</p>
        </section>
      );
    }
}
export default About;
  
